export const vms_gen3 = [
  { name: "VM01 Zerschneider", location: "Metarost City – vom Haus neben dem Markt" },
  { name: "VM02 Fliegen", location: "Route 119 – vom Mädchen nach Arenasieg" },
  { name: "VM03 Surfer", location: "Graphitport City – von einem Wissenschaftler im Museum" },
  { name: "VM04 Stärke", location: "Malvenfroh City – Haus rechts neben Radladen" },
  { name: "VM05 Blitz", location: "Höhlen von Route 106 – vom Wanderer" },
  { name: "VM06 Zertrümmerer", location: "Metarost City – Haus rechts vom Center" },
  { name: "VM07 Taucher", location: "Graphitport City – von Team Aqua/Magma-Forscher" },
  { name: "VM08 Kaskade", location: "Xeneroville – nach Arenasieg" }
];